<template>

  <div>
    <v-data-table :headers="headers"
                  :items="items"
                  :pagination.sync="pagination_"
                  :total-items="totalItems"
                  :rows-per-page-items="paginationOptions"
                  :loading="loading">
      <v-progress-linear slot="progress"
                         color="primary"
                         indeterminate="indeterminate"></v-progress-linear>
      <template slot="items" slot-scope="props" v-show="!loading">

        <!-- ID -->
        <td :class="$vuetify.breakpoint.name">
          <ExternalId :id="props.item.id" :path="'/club/' + props.item.id" />
        </td>

        <!-- LOGO -->
        <td :class="$vuetify.breakpoint.name">
          <div class="club-logo-container">
            <img class="club-logo-img" v-if="!props.item.logoURL" src="../../../static/icons/club-icon-256x256-darkblue.png"/>
            <img class="club-logo-img" v-if="props.item.logoURL" :src="props.item.logoURL"/>
          </div>
        </td>

        <!-- ALIAS -->
        <td :class="$vuetify.breakpoint.name"><b>{{ props.item.alias }}</b></td>

        <!-- SPORT -->
        <td :class="$vuetify.breakpoint.name">{{ getSportName(props.item.sportID) }}</td>

        <!-- TYPE -->
        <td :class="$vuetify.breakpoint.name" v-if="$country === 'US'">{{ props.item.type }}</td>

        <!-- REGION -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.regionName }}</td>

        <!-- BUTTONS -->
        <v-layout justify-end>
          <td class="buttons" :class="$vuetify.breakpoint.name">
            <v-icon class="clubs-button mr-1" title="Edit" @click="edit(props.index)">mdi-pencil</v-icon>
            <ProxyDeleteButton class="clubs-button" @click="del(props.item)"></ProxyDeleteButton>
          </td>
        </v-layout>

      </template>
    </v-data-table>
  </div>

</template>

<script>

import { getSportInfos } from '../../helpers/get-sport-infos'

import ProxyDeleteButton from '../common/ProxyDeleteButton'
import ExternalId from '../tables/ExternalId'

export default {
  name: 'Table',
  components: {
    ProxyDeleteButton,
    ExternalId
  },
  props: [
    'headers',
    'items',
    'pagination',
    'paginationOptions',
    'totalItems',
    'loading'
  ],
  methods: {
    getSportName (sportid) {
      return getSportInfos({id: sportid}).names['default']
    },
    edit (index) {
      this.$emit('edit', index)
    },
    del (item) {
      this.$emit('del', item)
    },
    copyButton (id) {
      navigator.clipboard.writeText(id)
    }
  },
  computed: {
    pagination_: {
      get () {
        return this.pagination
      },
      set (v) {
        window.scrollTo(0, 0)
        this.$emit('paginationUpdate', v)
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  td {
    &.xs {
      font-size: 11px !important;
      padding: 0 6px !important;
    }
  }

  .club-logo-container {
    background-color: white;
    border: 1px solid #888888;
    border-radius: 50%;
    overflow: hidden;
    width: 30px;
    height: 30px;
    display: grid;
  }

  .club-logo-img {
    max-width: 20px;
    max-height: 20px;
    align-self: center;
    justify-self: center;
  }

  .buttons {
    align-content: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/clubs/Table.vue